import http from '../http'

export default {
  getRollSections(code, pageReq) {
    return http.get(`/serialization/v1/sections/roll/${code}`, {
      params: pageReq
    })
  },

  activateStrech(firstCode, lastCode, data) {
    return http.put(`/rolls/v1/stretch/${firstCode}/${lastCode}`, data)
  },

  getRollInfo(code) {
    return http.get(`/rolls/v1/${code}`)
  },

  getRollTarget(code) {
    return http.get(`/rolls/v1/target/${code}`)
  },

  calibrateRoll(firstCode, secondCode) {
    return http.put(`/rolls/v1/direction/${firstCode}/${secondCode}`)
  },

  getActivations(code) {
    return http.get(`/rolls/v1/sections/roll/${code}`)
  },

  getChannelsWithCodeConfig() {
    return http.get('/kcengine-ws-rest/entrychannels', {
      params: {
        max: 1000
      }
    }).then((resp) => {
      const channels = resp.data.entryChannels.entryChannel
        .filter((c) => c.codeConfig)
        .map((c) => {
          let name = c.alias || c.phonenumber;
          if (c.prefix) {
            name += ` - ${c.prefix}`
          }
          return {
            id: c.id,
            name,
            cfgId: c.codeConfig.id
          }
        })
      return channels
    })
  },
  getSchemaById(id) {
    return http.get(`/serialization/v1/metadataschemas/${id}`)
  },
}



// WEBPACK FOOTER //
// ./src/service/apis/Activator.js